//core
import { createSelector } from "@reduxjs/toolkit";

//store
import {RootState} from "../../../index";

// state
const fullReportSelector = (state: RootState) => state.admin.full_report;

const fullReportOptionsSelector = (state: RootState) => state.admin.full_report.options;
const fullReportOptionsDataSelector = (state: RootState) => state.admin.full_report.options.data;
const fullReportOptionsErrorSelector = (state: RootState) => state.admin.full_report.options.error;
const fullReportOptionsFetchingSelector = (state: RootState) => state.admin.full_report.options.isFetching;

const fullReportListSelector = (state: RootState) => state.admin.full_report.list;
const fullReportListDataSelector = (state: RootState) => state.admin.full_report.list.data;
const fullReportListErrorSelector = (state: RootState) => state.admin.full_report.list.error;
const fullReportListFetchingSelector = (state: RootState) => state.admin.full_report.list.isFetching;

const fullReportDownloadSelector = (state: RootState) => state.admin.full_report.download;
const fullReportDownloadDataSelector = (state: RootState) => state.admin.full_report.download.data;
const fullReportDownloadErrorSelector = (state: RootState) => state.admin.full_report.download.error;
const fullReportDownloadFetchingSelector = (state: RootState) => state.admin.full_report.download.isFetching;

const fullReportAffiliatesSelector = (state: RootState) => state.admin.full_report.affiliates;
const fullReportAffiliatesDataSelector = (state: RootState) => state.admin.full_report.affiliates.data;
const fullReportAffiliatesErrorSelector = (state: RootState) => state.admin.full_report.affiliates.error;
const fullReportAffiliatesFetchingSelector = (state: RootState) => state.admin.full_report.affiliates.isFetching;

const fullReportTrackersSelector = (state: RootState) => state.admin.full_report.trackers;
const fullReportTrackersDataSelector = (state: RootState) => state.admin.full_report.trackers.data;
const fullReportTrackersErrorSelector = (state: RootState) => state.admin.full_report.trackers.error;
const fullReportTrackersFetchingSelector = (state: RootState) => state.admin.full_report.trackers.isFetching;

const fullReportDealsSelector = (state: RootState) => state.admin.full_report.deals;
const fullReportDealsDataSelector = (state: RootState) => state.admin.full_report.deals.data;
const fullReportDealsErrorSelector = (state: RootState) => state.admin.full_report.deals.error;
const fullReportDealsFetchingSelector = (state: RootState) => state.admin.full_report.deals.isFetching;

const fullReportCreativesSelector = (state: RootState) => state.admin.full_report.creatives;
const fullReportCreativesDataSelector = (state: RootState) => state.admin.full_report.creatives.data;
const fullReportCreativesErrorSelector = (state: RootState) => state.admin.full_report.creatives.error;
const fullReportCreativesFetchingSelector = (state: RootState) => state.admin.full_report.creatives.isFetching;

const fullReportProductsSelector = (state: RootState) => state.admin.full_report.products;
const fullReportProductsDataSelector = (state: RootState) => state.admin.full_report.products.data;
const fullReportProductsErrorSelector = (state: RootState) => state.admin.full_report.products.error;
const fullReportProductsFetchingSelector = (state: RootState) => state.admin.full_report.products.isFetching;

const fullReportManagersSelector = (state: RootState) => state.admin.full_report.managers;
const fullReportManagersDataSelector = (state: RootState) => state.admin.full_report.managers.data;
const fullReportManagersErrorSelector = (state: RootState) => state.admin.full_report.managers.error;
const fullReportManagersFetchingSelector = (state: RootState) => state.admin.full_report.managers.isFetching;

const fullReportBrandsSelector = (state: RootState) => state.admin.full_report.brands;
const fullReportBrandsDataSelector = (state: RootState) => state.admin.full_report.brands.data;
const fullReportBrandsErrorSelector = (state: RootState) => state.admin.full_report.brands.error;
const fullReportBrandsFetchingSelector = (state: RootState) => state.admin.full_report.brands.isFetching;

const fullReportCurrenciesSelector = (state: RootState) => state.admin.full_report.currencies;
const fullReportCurrenciesDataSelector = (state: RootState) => state.admin.full_report.currencies.data;
const fullReportCurrenciesErrorSelector = (state: RootState) => state.admin.full_report.currencies.error;
const fullReportCurrenciesFetchingSelector = (state: RootState) => state.admin.full_report.currencies.isFetching;

const fullReportPlatformsSelector = (state: RootState) => state.admin.full_report.platforms;
const fullReportPlatformsDataSelector = (state: RootState) => state.admin.full_report.platforms.data;
const fullReportPlatformsErrorSelector = (state: RootState) => state.admin.full_report.platforms.error;
const fullReportPlatformsFetchingSelector = (state: RootState) => state.admin.full_report.platforms.isFetching;

const fullReportColumnsDataSelector = (state: RootState) => state.admin.full_report.columns.data;
const fullReportColumnsErrorSelector = (state: RootState) => state.admin.full_report.columns.error;
const fullReportColumnsFetchingSelector = (state: RootState) => state.admin.full_report.columns.isFetching;

const fullReportRestoreStatisticsDatesSelector = (state: RootState) => state.admin.full_report.restoreStatisticsDates;
const fullReportRestoreStatisticsDatesDataSelector = (state: RootState) => state.admin.full_report.restoreStatisticsDates.data;
const fullReportRestoreStatisticsDatesErrorSelector = (state: RootState) => state.admin.full_report.restoreStatisticsDates.error;
const fullReportRestoreStatisticsDatesFetchingSelector = (state: RootState) => state.admin.full_report.restoreStatisticsDates.isFetching;

const fullReportRestoreStatisticsTaskSelector = (state: RootState) => state.admin.full_report.restoreStatisticsTask;
const fullReportRestoreStatisticsTaskDataSelector = (state: RootState) => state.admin.full_report.restoreStatisticsTask.data;
const fullReportRestoreStatisticsTaskErrorSelector = (state: RootState) => state.admin.full_report.restoreStatisticsTask.error;
const fullReportRestoreStatisticsTaskFetchingSelector = (state: RootState) => state.admin.full_report.restoreStatisticsTask.isFetching;

//selectors
export const selectFullReport = createSelector(fullReportSelector, (report) => report);

export const selectOptions = createSelector(fullReportOptionsSelector, (options) => options);
export const selectOptionsData = createSelector(fullReportOptionsDataSelector, (data) => data);
export const selectOptionsError = createSelector(fullReportOptionsErrorSelector, (error) => error);
export const selectOptionsIsFetching = createSelector(fullReportOptionsFetchingSelector, (isFetching) => isFetching);

//columns
export const selectColumnsData = createSelector(fullReportColumnsDataSelector, (data) => data);
export const selectColumnsError = createSelector(fullReportColumnsErrorSelector, (error) => error);
export const selectColumnsIsFetching = createSelector(fullReportColumnsFetchingSelector, (isFetching) => isFetching);

export const selectList = createSelector(fullReportListSelector, (list) => list);
export const selectListDataColumnsSort = createSelector(fullReportListDataSelector, (data) => data?.columns.filter((el: any) => el.sort === true));
const columnsFloat = [
  'poker_rake_sum',
  'poker_bonus',
  'ngr_poker',
  'poker_revenue_share_profit',
  'pkm_casino_bet_sum',
  'pkm_casino_ggr',
  'pkm_casino_bonus',
  'ngr_pkm_casino',
  'pkm_casino_revenue_share_profit',
];
export const selectListData = createSelector(fullReportListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.reduce((acc: any[], item: any) => {
      if (item.name === 'creative_group') {
        acc.push({
          name: "creative_id",
          sort: true,
          type: "string",
        });
        acc.push({
          name: "creative_name",
          sort: true,
          type: "shortString",
        });
      } else if (item.name === 'tracker_group') {
        acc.push({
          name: "tracker_id",
          sort: true,
          type: "string",
        });
        acc.push({
          name: "tracker_description",
          sort: true,
          type: "shortString",
        });
      } else if (item.name === 'affiliate_group') {
        acc.push({
          name: "affiliate_id",
          sort: true,
          type: "clickableUserId",
        });
        acc.push({
          name: "affiliate_name",
          sort: true,
          type: "shortUsername",
        });
      } else if (item.name === 'transaction_date_for_reports') {
        acc.push({ ...item, type: 'datetime' });
      } else if (item.name === 'chief_name') {
        acc.push({ ...item, type: 'shortString' });
      } else if (item.name === 'landing_url') {
        acc.push({ ...item, type: 'link' });
      } else if (columnsFloat.includes(item.name)) {
        acc.push({ ...item, type: 'float' });
      } else if ((item.name === "anid")) {
        acc.push({ ...item, type: 'mediumString' });
      } else if ((item.name === "filter_type")) {
        acc.push({ ...item, type: 'filter_type' });
      } else {
        acc.push({ ...item })
      }
      return acc;
    }, []);

    return { ...data, columns: columns };
  } else {
    return data;
  }
});
export const selectListError = createSelector(fullReportListErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(fullReportListFetchingSelector, (isFetching) => isFetching);

export const selectDownload = createSelector(fullReportDownloadSelector, (data) => data);
export const selectDownloadData = createSelector(fullReportDownloadDataSelector, (data) => data);
export const selectDownloadError = createSelector(fullReportDownloadErrorSelector, (error) => error);
export const selectDownloadIsFetching = createSelector(fullReportDownloadFetchingSelector, (isFetching) => isFetching);

export const selectAffiliates = createSelector(fullReportAffiliatesSelector, (data) => data);
export const selectAffiliatesData = createSelector(fullReportAffiliatesDataSelector, (data) => data);
export const selectAffiliatesError = createSelector(fullReportAffiliatesErrorSelector, (error) => error);
export const selectAffiliatesIsFetching = createSelector(fullReportAffiliatesFetchingSelector, (isFetching) => isFetching);

export const selectTrackers = createSelector(fullReportTrackersSelector, (data) => data);
export const selectTrackersData = createSelector(fullReportTrackersDataSelector, (data) => data);
export const selectTrackersError = createSelector(fullReportTrackersErrorSelector, (error) => error);
export const selectTrackersIsFetching = createSelector(fullReportTrackersFetchingSelector, (isFetching) => isFetching);

export const selectDeals = createSelector(fullReportDealsSelector, (data) => data);
export const selectDealsData = createSelector(fullReportDealsDataSelector, (data) => data);
export const selectDealsError = createSelector(fullReportDealsErrorSelector, (error) => error);
export const selectDealsIsFetching = createSelector(fullReportDealsFetchingSelector, (isFetching) => isFetching);

export const selectCreatives = createSelector(fullReportCreativesSelector, (data) => data);
export const selectCreativesData = createSelector(fullReportCreativesDataSelector, (data) => data);
export const selectCreativesError = createSelector(fullReportCreativesErrorSelector, (error) => error);
export const selectCreativesIsFetching = createSelector(fullReportCreativesFetchingSelector, (isFetching) => isFetching);

export const selectProducts = createSelector(fullReportProductsSelector, (data) => data);
export const selectProductsData = createSelector(fullReportProductsDataSelector, (data) => data);
export const selectProductsError = createSelector(fullReportProductsErrorSelector, (error) => error);
export const selectProductsIsFetching = createSelector(fullReportProductsFetchingSelector, (isFetching) => isFetching);

export const selectManagers = createSelector(fullReportManagersSelector, (data) => data);
export const selectManagersData = createSelector(fullReportManagersDataSelector, (data) => data);
export const selectManagersError = createSelector(fullReportManagersErrorSelector, (error) => error);
export const selectManagersIsFetching = createSelector(fullReportManagersFetchingSelector, (isFetching) => isFetching);

export const selectBrands = createSelector(fullReportBrandsSelector, (data) => data);
export const selectBrandsData = createSelector(fullReportBrandsDataSelector, (data) => data);
export const selectBrandsError = createSelector(fullReportBrandsErrorSelector, (error) => error);
export const selectBrandsIsFetching = createSelector(fullReportBrandsFetchingSelector, (isFetching) => isFetching);

export const selectCurrencies = createSelector(fullReportCurrenciesSelector, (data) => data);
export const selectCurrenciesData = createSelector(fullReportCurrenciesDataSelector, (data) => data);
export const selectCurrenciesError = createSelector(fullReportCurrenciesErrorSelector, (error) => error);
export const selectCurrenciesIsFetching = createSelector(fullReportCurrenciesFetchingSelector, (isFetching) => isFetching);

export const selectPlatforms = createSelector(fullReportPlatformsSelector, (data) => data);
export const selectPlatformsData = createSelector(fullReportPlatformsDataSelector, (data) => data);
export const selectPlatformsError = createSelector(fullReportPlatformsErrorSelector, (error) => error);
export const selectPlatformsIsFetching = createSelector(fullReportPlatformsFetchingSelector, (isFetching) => isFetching);

export const selectRestoreStatisticsDates = createSelector(fullReportRestoreStatisticsDatesSelector,(data) => data);
export const selectRestoreStatisticsDatesData = createSelector(fullReportRestoreStatisticsDatesDataSelector,(data) => data);
export const selectRestoreStatisticsDatesError = createSelector(fullReportRestoreStatisticsDatesErrorSelector,(error) => error);
export const selectRestoreStatisticsDatesIsFetching = createSelector(fullReportRestoreStatisticsDatesFetchingSelector,(isFetching) => isFetching);

export const selectRestoreStatisticsTask = createSelector(fullReportRestoreStatisticsTaskSelector,(data) => data);
export const selectRestoreStatisticsTaskData = createSelector(fullReportRestoreStatisticsTaskDataSelector,(data) => data);
export const selectRestoreStatisticsTaskError = createSelector(fullReportRestoreStatisticsTaskErrorSelector,(error) => error);
export const selectRestoreStatisticsTaskIsFetching = createSelector(fullReportRestoreStatisticsTaskFetchingSelector,(isFetching) => isFetching);
